import { useCallback } from "react";

import { useNavigate } from "react-router-dom";

const useAppNavigate = () => {
  const navigate = useNavigate();

  const appNavigate = useCallback((path, options) => {
    let slug = "/";
    let rootdir = "series";
    if (window.location.pathname.match(/\//g).length > 1) {
      rootdir = window.location.pathname.split("/")[1];
      slug = window.location.pathname.split("/")[2];
    }
    navigate(`/${rootdir}/${slug}/${path}`, options);
  }, [navigate]);

  return appNavigate;
};

export default useAppNavigate;
